import React, { Component } from 'react';
import SubSequencesComponent from 'components/toolbar/SubSequencesComponent.js';

class SubSequencesDocumentation extends Component {
    render() {
        return (
            <div>
              <p>
                Projects can be further organized via sub-sequences. Sub-sequences divide a project
                by tracks. 
              </p>
              <p>
                For example, you can have your drums on one sub-sequence, and your instruments on another.
              </p>
              <p>
                This can keep the interface uncluttered, as you limit how many tracks are in each sub-sequence.
              </p>
              <p>
                To setup sub-sequences, look to the right of the pattern buttons, for a box containing the
                letter <b>A</b> and <b>plus</b> and <b>minus</b> buttons.
                <div>
                  <SubSequencesComponent sequencerEngine={this.props.sequencerEngine}/>
                </div>
                <div className="clear-fix"/>
              </p>
              <p>
                Sub-sequences are named by letters, starting with A (the first one).
              </p>
              <p>
                You can create new sub-sequences by pressing the plus-button. You can switch
                to sub-sequences by clicking on the letter.
              </p>
              <p>
                Each sub-sequence has their own set of independent LFOs and Envelopes that
                can be modified without affecting the other sub-sequences. Think of sub-sequences
                as parallel projects that are played together.
              </p>
              <p>
                If you load another project, while working on another project, the new
                project will be loaded as its own sub-sequence. This prevents
                the new sub-sequence from interfering with any modulators you’ve already set.
              </p>
            </div>
        );
    }
}

export default SubSequencesDocumentation;
